import React from "react";
import CoreEngine from "../../core/CoreEngine";
import FormPage from "../../components/Form/FormPage";
import BranchPhotoForm from "./BranchPhotoForm";
import strings from "../../core/translate";

// Direct link version of the photo dialog used on the photos list.
export default class MerchantBranchPhotoAddUpdate extends CoreEngine {
  getContext() {
    const routeState = this.props.location.state || {};
    const { selectedBranch } = this.props.match.params;
    return {
      selectedBranch: routeState.selectedBranch || selectedBranch,
      selectedMerchant: routeState.selectedMerchant,
      branchName: routeState.branchName,
    };
  }

  handleDone = () => {
    const { selectedBranch, selectedMerchant, branchName } = this.getContext();
    this.props.history.push({
      pathname: `/admin/merchant-branch/${selectedBranch}/photos`,
      state: { selectedMerchant, selectedBranch, branchName },
    });
  };

  render() {
    const { selectedBranch, branchName } = this.getContext();
    const item = this.props.location.data;

    return (
      <FormPage
        title={
          item && item.id
            ? `${strings.edit} ${strings.picture}`
            : `${strings.add} ${strings.photos}`
        }
        subtitle={branchName}
      >
        <BranchPhotoForm
          item={item}
          branchId={selectedBranch}
          onSaved={this.handleDone}
          onCancel={this.handleDone}
        />
      </FormPage>
    );
  }
}
